import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="copy-html"
// Copia el HTML de un envío al portapapeles para reutilizarlo en un envío nuevo
// sin clonar. El HTML llega como value (data-copy-html-html-value) y la
// confirmación se anuncia en la región aria-live (target "feedback").
export default class extends Controller {
  static values = { html: String }
  static targets = ["feedback"]

  async copy() {
    try {
      await navigator.clipboard.writeText(this.htmlValue)
      this.announce("HTML copiado al portapapeles")
    } catch {
      this.announce("No se ha podido copiar. Copia el HTML manualmente.")
    }
  }

  announce(message) {
    if (this.hasFeedbackTarget) {
      this.feedbackTarget.textContent = message
    }
  }
}
